module.exports = __webpack_public_path__ + "static/mid2-383453d2f0707efa990443c2045d6182.png";